import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

interface AuthSuccessBannerProps {
  isVisible: boolean;
  onClose: () => void;
}

export function AuthSuccessBanner({ isVisible, onClose }: AuthSuccessBannerProps) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(onClose, 5000); // Auto-close after 5 seconds
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: -100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -100 }}
          className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50"
        >
          <div className="bg-white rounded-lg shadow-lg border border-green-100 p-4 flex items-center gap-3">
            <div className="bg-green-50 rounded-full p-1">
              <CheckCircle className="w-5 h-5 text-green-500" />
            </div>
            <div>
              <h3 className="font-medium">Welcome!</h3>
              <p className="text-sm text-gray-600">Your free plan has been activated</p>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}